import { render, staticRenderFns } from "./AtomImage.vue?vue&type=template&id=a0451c64&"
import script from "./AtomImage.vue?vue&type=script&lang=ts&"
export * from "./AtomImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports